import React, { useState, useContext, useEffect, useReducer } from 'react';
import { Formik } from "formik";
import * as Yup from "yup";
import "../../site.css";
import { Button, Modal } from 'react-bootstrap';
import { AuthContext } from "../../AuthContext";
import { Redirect } from "react-router-dom";
import { getAPI } from '../GdacsAPI';

const UserDelete = (props) => {
    const authContext = useContext(AuthContext);
    const initDataObject = { username: authContext.username, password: "" }
    const [user, setUser] = React.useState(initDataObject);
    const [responseMessage, setResponseMessage] = React.useState("");
    const [isDeleted, setIsDeleted] = React.useState(false);
    const [show, setShow] = React.useState(false);
    const [isClosed, setIsClosed] = React.useState(false);

    const handleClose = () => {
        setShow(false);
        setIsDeleted(undefined);
        setIsClosed(true);
    }

    const handleCancel = () => {
        setShow(false);
        setIsDeleted(undefined);
    }

    if (isClosed) {
        authContext.logout();
        return <Redirect to={"/"} />
    }

    const handleShow = () => {
        setShow(true);
    }

    const checkValidation = Yup.object().shape({
        password: Yup.string().required("No password provided.")
    })

    async function DeleteUser(values) {
        let json = {
            username: authContext.username,
            password: values.password
        }

        const settings = {
            method: 'POST',
            body: JSON.stringify(json),
            headers: {
                'Authorization': 'Bearer ' + authContext.token,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        };

        const response = await fetch(getAPI() + `api/register/Users/deleteuser/`, settings);
        if (!response.ok) {
            const resp = await response.json();
            setResponseMessage(resp.message);
            return;
        }
        else {
            setResponseMessage("Your Account has been deleted.");
            setIsDeleted(true);
            ////authContext.logout();
            ////return <Redirect to={"/"} />
        }

    }

    const handleFormikSubmit = (values, { setSubmitting }) => {
        setSubmitting(false);
        DeleteUser(values);
    }

    return (
        <Formik
            initialValues={initDataObject}
            validationSchema={checkValidation}
            onSubmit={handleFormikSubmit}
        >
            {({
                values,
                touched,
                errors,
                handleChange,
                handleBlur,
                handleSubmit
            }) => (
                <div className="alerts_container col-12">
                    <form>
                        <div>
                            <br />
                            <h4 className="d-flex justify-content-center hr-title">Unsubscribe your User Account</h4>
                            <br />
                            <br />
                            <div className="p_summary">
                                Unsubscribe from the service. Your account will be deleted.
                                Are you sure you want to unsubscribe from the service?
                                In case, please enter you password.
                            </div>
                            <br />
                            <br/>
                            <div>
                                <label className="label-user" htmlFor="password">Password</label>
                                <input className="form-control form-control-sm"
                                    name="password"
                                    type="password"
                                    placeholder="Enter your password"
                                    value={values.password}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.password && touched.password && (
                                    <div className="input-feedback">{errors.password}</div>
                                )}
                            </div>
                            {/*{responseMessage &&*/}
                            {/*    <div className="input-feedback">{responseMessage}</div>*/}
                            {/*}*/}
                            <br />
                            <br />
                            <div style={{ paddingRight: "20px" }}>
                                <Button className="float-right btn btn-primary" variant="primary" onClick={handleShow}>
                                    Confirm
                                    </Button>
                            </div>
                            <br />
                            <br />
                            <br />
                            <Modal show={show} onHide={handleClose}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Unsubscribe Your Account</Modal.Title>
                                </Modal.Header>
                                {isDeleted &&
                                    <><Modal.Body>{responseMessage}</Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="primary" onClick={handleClose}>
                                                Ok
                                                    </Button>
                                        </Modal.Footer></>
                                }
                                {!isDeleted &&
                                    <><Modal.Body>If you click on button confirm, your account will be deleted. </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="primary" onClick={handleSubmit}>
                                                Confirm
                                            </Button>
                                            <Button variant="secondary" onClick={handleCancel}>
                                                Cancel
                                            </Button>

                                        </Modal.Footer></>
                                }
                            </Modal>
                        </div>
                    </form>
                    <br />
                    <br />
                </div>
            )}
        </Formik>
    );
}
export { UserDelete }